<div id="side-menu" [hidden]="isHidden" [ngClass]="'collapsed'"
  class=" d-none d-lg-block ">
    <div class="fixed-top" [hidden]="isHidden" [ngClass]="'menu-container-collapsed'">
      <div class="menu-links">
        <a (click)="clearIds()" [ngClass]="{'selected': currentPage === '/myaccount',
          'semilight': currentPage !== '/myaccount'
          }" [routerLink]="['/myaccount/']" routerLinkActive="router-link-active">
        <span class="menu-account-icon" [ngClass]="{ selected: currentPage === '/myaccount'}">
            <img *ngIf="authService.photoUrl; else initials"[src]="authService.photoUrl" alt="User photo" class="account-photo" />
          <ng-template #initials>
            <span class="inner-circle">
              {{ getInitial(userName) }}
            </span>
          </ng-template>
        </span>
        <span class="menu-text">My Account</span>
      </a>
        <a (click)="clearIds()"
          [ngClass]="{ 'selected': currentPage === ''  && !isNotInBranch, 'not-in-branch': isNotInBranch,'semilight': currentPage !== '', 'menu-disabled': stockCheckRequired }"
          [routerLink]="['']" routerLinkActive="router-link-active">
          <span class="menu-icon diary-icon"
            [ngClass]="{ 'selected': currentPage === '' && !isNotInBranch, 'not-in-branch diary-icon-red': isNotInBranch }"></span>
          <span>Diary</span>
        </a>
        <a (click)="clearIds()"
          [ngClass]="{ selected: currentPage === '/tasks', semilight: currentPage !== '/tasks', 'menu-disabled': stockCheckRequired }"
          [routerLink]="['/tasks/']" routerLinkActive="router-link-active">
          <span class="menu-icon" [ngClass]="{ 'selected':currentPage === '/tasks' }"
            style="background-image: url('../../assets/icons/menu/task-blue.svg');"></span>
          <span class="tasks-min-width">Tasks</span>
          <div [hidden]="userTaskCount === 0" class="counter task">{{ userTaskCount }}</div>
          <div [hidden]="authTaskCount === 0" class="counter auth">{{ authTaskCount }}</div>
        </a>
        <a (click)="clearIds()" [ngClass]="{'selected': currentPage === '/stock',
          'semilight': currentPage !== '/stock',
          'menu-disabled': isNotInBranch
          }" [routerLink]="['/stock/']" routerLinkActive="router-link-active">
        <span class="menu-icon" [ngClass]="{ selected: currentPage === '/stock'}" style="
              background-image: url('../../assets/icons/menu/stock-check.svg');
            "></span>
        <span>Stock</span>
      </a>
      <a (click)="clearIds()"
        [ngClass]="{'selected': currentPage === dashboardPath, 'semilight': currentPage !==  dashboardPath}"
        [hidden]="!canViewDashboard" [routerLink]="[dashboardPath]" routerLinkActive="router-link-active">
        <span class="menu-icon" [ngClass]="{ selected: currentPage === dashboardPath}"
          style="background-image: url('../../assets/icons/menu/chart.svg');"></span>
        <span>Dashboard</span>
      </a>
      <a (click)="clearIds()" [ngClass]="{
            selected: currentPage === '/review',
            semilight: currentPage !== '/review',
            'menu-disabled': stockCheckRequired}" [hidden]="!canReviewPurchases" [routerLink]="['/review/']" routerLinkActive="router-link-active">
          <span class="menu-icon" [ngClass]="{ selected: currentPage === '/review' }"
            style="background-image: url('../../assets/icons/menu/car-hand.svg')"></span>
          <span>Purchases</span>
        </a>
        <a (click)="clearIds()" [ngClass]="{'selected': currentPage === '/upjar', 'semilight': currentPage !== '/upjar'}"
          [hidden]="!canViewUpjar" [routerLink]="['/upjar/']" routerLinkActive="router-link-active">
          <span class="menu-icon" [ngClass]="{ selected: currentPage === '/upjar'}"
            style="background-image: url('../../assets/icons/menu/upjar.svg');"></span>
          <span>Upjar</span>
        </a>
   </div>
  </div>
  <div class="menu-version">
    <div class="text-center version-text">v{{version}}</div>
  </div>
</div>